export const KOREA_TIME_ZONE = "Asia/Seoul";

const koreaDateFormatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: KOREA_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export function getKoreaDateString(date = new Date()) {
  const parts = koreaDateFormatter.formatToParts(date).reduce((acc, part) => {
    acc[part.type] = part.value;
    return acc;
  }, {});
  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function addKoreaDaysString(days, baseDate = new Date()) {
  const [year, month, day] = getKoreaDateString(baseDate).split("-").map(Number);
  const shifted = new Date(Date.UTC(year, month - 1, day + days, 12, 0, 0));
  return getKoreaDateString(shifted);
}
